import { useQuery } from '@tanstack/react-query';

import {
  FetchSavingsRequest,
  FetchSavingsResponse,
  savingsService,
  useToast,
} from '@aslanpay/portal-common-lib';

const useFetchSavings = (params: FetchSavingsRequest, enabled = true) => {
  const toast = useToast();

  return useQuery<FetchSavingsResponse, Error>(
    ['fetchSavings', params],
    () => savingsService.fetchSavings(params),
    {
      enabled,
      onError: () => {
        toast({
          position: 'top-right',
          status: 'error',
          title: 'Something went wrong',
          description: 'Sorry, we failed to fetch the savings. Please try again.',
        });
      },
    }
  );
};

export default useFetchSavings;
